import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Settings } from 'lucide-react';

interface BackToPracticeButtonProps {
  showChangeWords?: boolean;
  size?: "sm" | "default" | "lg" | "icon";
}

function BackToPracticeButton({ showChangeWords = false, size = "sm" }: BackToPracticeButtonProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleChangeWords = () => {
    const wordParam = searchParams.get('w');
    navigate(`/practice/fill-in-the-blank-select${wordParam ? `?w=${wordParam}` : ''}`);
  };

  return (
    <div className="mb-2">
      <div className="flex justify-between items-center">
        <Button
          variant="outline"
          size={size}
          onClick={() => navigate('/practice')}
          className="gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Practice
        </Button>

        {showChangeWords && (
          <Button
            variant="outline"
            size={size}
            onClick={handleChangeWords}
            className="gap-2"
          >
            <Settings className="h-4 w-4" />
            Change Words
          </Button>
        )}
      </div>
    </div>
  );
}

export default BackToPracticeButton;
